export default "__VITE_ASSET__CgJRUIP3__"